import { useCallback } from 'react';
import { useAppData } from '../contexts/AppDataContext';
import { addCalendarDays, genId } from '../../lib/util';

export interface AdminActions {
  logLegalProcess: (caseId: string, description: string) => void;
  confirmBcidNotification: (caseId: string, lpId: string) => void;
}

export function useAdminActions(): AdminActions {
  const { cases, updateCase } = useAppData();

  const logLegalProcess = useCallback((caseId: string, description: string) => {
    const entry = { id: genId('LP'), description, loggedAt: new Date().toISOString(), bcidNotifiedAt: null, notifyDeadline: addCalendarDays(new Date(), 1).toISOString() };
    const c = cases.find(x => x.id === caseId)!;
    updateCase(caseId, {
      legalProcessNotifications: [...(c.legalProcessNotifications || []), entry],
      action: { code: 'LEGAL_PROCESS_RECEIVED', detail: { description, notifyWindowHours: 24 } },
    });
  }, [cases, updateCase]);

  const confirmBcidNotification = useCallback((caseId: string, lpId: string) => {
    const c = cases.find(x => x.id === caseId)!;
    const updated = (c.legalProcessNotifications || []).map((lp: any) => lp.id === lpId ? { ...lp, bcidNotifiedAt: new Date().toISOString() } : lp);
    updateCase(caseId, {
      legalProcessNotifications: updated,
      action: { code: 'BCID_LLC_NOTIFIED', detail: { lpId } },
    });
  }, [cases, updateCase]);

  return { logLegalProcess, confirmBcidNotification };
}
